/**
 * Well-known project template identifiers.
 *
 * These constants are isolated from the legacy `projectTemplateManager` so that
 * consumers (e.g. the compatibility patch handler) can reference them without
 * loading the whole manager module.
 */
export const KnownProjectTemplate = {
    System: {
        Workflow: {
            DE: "70282E3CA73A4B01884201F504FCA194",
            EN: "3C9A5A472A59526BABB64C84365304E5",
            ES: "BD9C8DFE3F2E41EDBFA84627AAEDBC87",
            FR: "9FB933D99C4D4AE2AB79E60D6FBEF371",
            IT: "E7FE37D7D4ECA8E15E8EF1E460022169",
        },
        WorkflowComplexe: {
            DE: "D182F9CBBEBF4CF8AE62CBD1AAEDB743",
            EN: "FD200747F4B1E99C39CB742C0B8E4C84",
            ES: "8F131903B1974CBEA10950C6EB1A5841",
            FR: "3432862658B9C497930B8C1E9B499AC9",
            IT: "246915ED4E61A92A429B0823E23FFAF5",
        },
    },
    Cogedim: "D531FD014071D34AD205727529BE5700",
    Promoimmo: "831DA8A6A0F9AA28E3F9C0CAD530ABAD",
} as const;
